<div class="card-container mat-elevation-z1">
    <form class="identification-control" [formGroup]="form">
        <div class="card-content">
            <div class="card-box-medium margin-right-small">
                <h4>Identificación</h4>
                <mat-divider></mat-divider>
                <mat-form-field class="full-width">
                    <input type="text" matInput placeholder="Protocolo" formControlName="Protocol">
                </mat-form-field>
                <mat-form-field class="full-width">
                    <input type="text" matInput placeholder="Paciente" formControlName="PatientFullName">
                </mat-form-field>
                <mat-form-field class="full-width">
                    <input type="text" matInput placeholder="Práctica" formControlName="PracticeRegionName">
                </mat-form-field>
                <mat-form-field class="full-width">
                    <input type="text" matInput placeholder="Región" formControlName="RegionName">
                </mat-form-field>
               
            </div>
            <div class="card-box-medium margin-right-small">
                <h4>Restricciones y observaciones</h4>
                <mat-divider></mat-divider>

                <mat-form-field *ngIf="validMedicalOrderState && validMedicalOrderAmount" class="full-width">
                    <input type="text" formControlName="MedicalOrderState" matInput placeholder="Estado de la entrega">
                </mat-form-field>
                <mat-form-field *ngIf="!validMedicalOrderAmount" class="full-width">
                    <input type="text" class="invalid-control" matInput placeholder="Cobranza pendiente" formControlName="MedicalOrderAmount">
                </mat-form-field>
                <mat-form-field *ngIf="!validMedicalOrderState" class="full-width">
                    <input type="text" class="invalid-control" class="invalid-control" formControlName="MedicalOrderState" matInput placeholder="Estado de la entrega">
                </mat-form-field>
                <ul *ngIf="missingDocumentation && missingDocumentation.length > 0">
                    <li *ngFor="let item of missingDocumentation; let i = index">
                        {{item}}
                    </li>
                </ul>
                <mat-form-field class="full-width">
                    <textarea class="full-width" matInput formControlName="PlatesDelivery" placeholder="Entrega placas"></textarea>
                </mat-form-field>
                <mat-form-field class="full-width">
                    <textarea class="full-width" matInput formControlName="PlatesAmount" placeholder="Cantidad placas"></textarea>
                </mat-form-field>
                <mat-form-field class="full-width">
                    <textarea class="full-width" matInput formControlName="CdDelivery" placeholder="Entrega cd"></textarea>
                </mat-form-field>
                <mat-form-field class="full-width">
                    <textarea class="full-width" matInput formControlName="Observation" placeholder="Observaciones"></textarea>
                </mat-form-field>
                <mat-form-field class="full-width">
                    <textarea class="full-width" matInput formControlName="DeliveryObservation" placeholder="Observaciones entrega"></textarea>
                </mat-form-field>
            </div>
        </div>
    </form>
</div>